<div class="top-title-bar">
  <h2 class="page-title">Home</h2>
</div>
<div class="white-box">
  <div id="userReportsContainer" [style.height.px]="reportHeight">
    <div  *ngIf="!IsPowerBIReport">
      <iframe [src]="safeSrc" [style.height.px]="reportHeight" width="100%"></iframe>
   </div>
  </div>
</div>